import { render } from "./singleBoxSearch.vue?vue&type=template&id=613138f6&scoped=true"
import script from "./singleBoxSearch.vue?vue&type=script&lang=js"
export * from "./singleBoxSearch.vue?vue&type=script&lang=js"

import "./singleBoxSearch.vue?vue&type=style&index=0&id=613138f6&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-613138f6"

export default script